import Vue from 'vue'
import { getToken } from '@/utils/storage'
import { promptLoginOnce } from '@/utils/authGuard'
import VueRouter from 'vue-router'
import HomeView from '../views/home'
import ShopView from '../views/shop/index.vue'
import Login from '../views/login/login.vue'
import Register from '../views/login/register.vue'
import SetPass from '../views/login/setPass.vue'
import Booking from '../views/booking/index.vue'
import OrderView from '../views/order/index.vue'
import OrderDetail from '../views/order/detail.vue'
import GiftCard from '../views/giftCard/index.vue'
import GiftCardDetail from '../views/giftCard/detail.vue'
import GiftCardBuy from '../views/giftCard/buy.vue'
import GiftCardSuccess from '../views/giftCard/success.vue'
import GiftCardCancel from '../views/giftCard/cancel.vue'
import MyGiftCard from '../views/myGiftCard/index.vue'
import MyGiftCardDetail from '../views/myGiftCard/detail.vue'
import ShopSettled from '../views/shop/settled.vue'
import MyCollection from '../views/collection/index.vue'
import PayOrder from '../views/pay/order.vue'
import SalesOrder from '../views/order/salesOrder.vue'
import AccountSetting from '../views/account/index.vue'
import AccountAvatar from '../views/account/avatar.vue'
import AccountNickname from '../views/account/nickname.vue'
import AccountEmail from '../views/account/email.vue'
import AccountPassword from '../views/account/password.vue'
import { maybeFixStripeNestedHistory } from '@/utils/stripeHistoryFix'
import RefundOrder from '../views/order/refundOrder.vue'
import RefundDetail from '../views/order/refundDetail.vue'
import OrderCollection from '../views/order/collection.vue'
import MyComment from '../views/comment/index.vue'
Vue.use(VueRouter)
export const constantRouterMap = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/setPass',
    name: 'setPass',
    component: SetPass
  },
  {
    path: '/shop',
    name: 'shop',
    component: ShopView
  },
  {
    path: '/booking',
    name: 'booking',
    component: Booking,
    meta: { requiresAuth: true }
  },
  {
    path: '/payOrder',
    name: 'payOrder',
    component: PayOrder,
    meta: { requiresAuth: true }
  },
]
export const asyncRouterMap = [
    {
        path: '/order',
        name: 'order',
        component: OrderView,
        meta: { requiresAuth: true }
    },
    {
        path: '/myGiftCard',
        name: 'myGiftCard',
        component: MyGiftCard,
        meta: { requiresAuth: true }
    },
    {
        path: '/myGiftCardDetail',
        name: 'myGiftCardDetail',
        component: MyGiftCardDetail,
        meta: { requiresAuth: true }
    },
    {
        path: '/giftCard',
        name: 'giftCard',
        component: GiftCard,
        meta: { requiresAuth: true }
    },
    {
        path: '/giftCardDetail',
        name: 'giftCardDetail',
        component: GiftCardDetail,
        meta: { requiresAuth: true }
    },
    {
        path: '/giftCardBuy',
        name: 'giftCardBuy',
        component: GiftCardBuy,
        meta: { requiresAuth: true }
    },
    {
        path: '/giftCardSuccess',
        name: 'giftCardSuccess',
        component: GiftCardSuccess,
        meta: { requiresAuth: true }
    },
    {
        path: '/giftCardCancel',
        name: 'giftCardCancel',
        component: GiftCardCancel,
        meta: { requiresAuth: true }
    },
    {
        path: '/myCollection',
        name: 'myCollection',
        component: MyCollection,
        meta: { requiresAuth: true }
    },
    {
        path: '/orderDetail',
        name: 'orderDetail',
        component: OrderDetail,
        meta: { requiresAuth: true }
    },
    {
      path: '/sales',
      name: 'sales',
      component: SalesOrder,
      meta: { requiresAuth: true }
    },
    {
      path: '/shopSettled',
      name: 'shopSettled',
      component: ShopSettled,
      meta: { requiresAuth: true }
    },
    {
      path: '/refundOrder',
      name: 'refundOrder',
      component: RefundOrder,
      meta: { requiresAuth: true }
    },
    {
      path: '/refundDetail',
      name: 'refundDetail',
      component: RefundDetail,
      meta: { requiresAuth: true }
    },
    {
      path: '/orderCollection',
      name: 'orderCollection',
      component: OrderCollection,
      meta: { requiresAuth: true }
    },
    {
      path: '/account',
      name: 'account',
      component: AccountSetting,
      meta: { requiresAuth: true }
    },
    {
      path: '/comment',
      name: 'comment',
      component: MyComment,
      meta: { requiresAuth: true }
    },
    { path: '/account/avatar', name: 'accountAvatar', component: AccountAvatar, meta: { requiresAuth: true } },
    { path: '/account/nickname', name: 'accountNickname', component: AccountNickname, meta: { requiresAuth: true } },
    { path: '/account/email', name: 'accountEmail', component: AccountEmail, meta: { requiresAuth: true } },
    { path: '/account/password', name: 'accountPassword', component: AccountPassword, meta: { requiresAuth: true } },
]
const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes:[...constantRouterMap,...asyncRouterMap]
})
router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.requiresAuth && !getToken()) {
        promptLoginOnce(to.fullPath)
        next(false)
        return
    }
    // 已登录访问登录页：回首页
    if (to.path === '/login' && getToken()) {
        next('/')
        return
    }
    next()
})
// Remove Stripe Checkout from the back stack after returning (prevents "back -> Stripe" nesting).
router.afterEach(() => {
  maybeFixStripeNestedHistory(router)
})
export default router
